import THEME, { ColorPalette, Theme } from "constants/theme"

export const useTheme = (): Theme => {
  return THEME
}

export const useThemeColors = (): ColorPalette => {
  return useTheme().colors.light
}
